import { StyleSheet } from 'react-native';
import theme from '@/config/theme';

export const styles = StyleSheet.create({
  outerContainer: {
    flex: 1.5,
    alignItems: 'center',
    padding: theme.spacings.sm,
  },
  innerContainer: {
    flex: 1,
    backgroundColor: theme.colors.white,
  },
  visibleWord: {
    color: theme.colors.black,
    fontFamily: 'ABeeZeeRegular',
  },
  hiddenWord: {
    color: 'transparent',
    fontFamily: 'ABeeZeeRegular',
  },
});
